"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePasswordStrength = void 0;
const react_1 = require("react");
const zxcvbn_1 = __importDefault(require("zxcvbn"));
function usePasswordStrength(password, dictionary) {
    const { guesses, score, feedback: { warning, suggestions }, crack_times_display: { offline_fast_hashing_1e10_per_second: timeToCrack }, } = (0, react_1.useMemo)(() => (0, zxcvbn_1.default)(password, dictionary), [password, dictionary]);
    return {
        guesses,
        score,
        warning,
        suggestions,
        timeToCrack,
    };
}
exports.usePasswordStrength = usePasswordStrength;
